export default "__VITE_ASSET__GvTeUMNZ__"